


import React from 'react';
import profileImage from '../assets/profile.jpg'; 
import StarIcon from '@mui/icons-material/Star';
import BadgeIcon from '@mui/icons-material/Badge';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const testimonials = [
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  {
    name: "John Doe",
    trips: "1,500 trips",
    joined: "Joined August 2022",
    review: "Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended! Great experience! The car was top-notch, and the service was beyond expectations. Highly recommended!",
  },
  // Add more testimonials as needed
];

const Testimonials = () => {
  return (
    <div className="w-full h-auto bg-white mt-4 md:mt-0 md:px-16">
      <h2 className="text-[#FF9630] md:text-4xl text-3xl font-semibold text-center mt-8 ">What People Say About Us</h2>
      <p className="text-left md:ml-0  text-gray-600 font-normal mb-8 p-2">Top hosts on MoveonWheels</p>
      
      <Swiper
        spaceBetween={30}
        slidesPerView="auto"
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 1000, // Slide every 3 seconds
          disableOnInteraction: false, // Keep autoplay running even after user interaction
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}> 
            <div className="bg-white  rounded-lg p-10 flex flex-col items-start border m-4 md:m-0">
              <div className="flex items-center mb-4">
                <img src={profileImage} alt="Profile" className="w-16 h-16 rounded-full mr-4" />
                <div>
                  <h3 className="text-gray-900 font-semibold">{testimonial.name}</h3>
                  <div className="flex items-center text-sm text-gray-600">
                    <BadgeIcon className="w-4 h-4 mr-1" />
                    <span>All-Star Host</span>
                  </div>
                  <p className="text-sm text-gray-500">{testimonial.trips} • {testimonial.joined}</p>
                </div>
              </div>
              <div className="flex mb-4">
                {Array(5).fill().map((_, i) => (
                  <StarIcon key={i} className="text-[#FF9630]" />
                ))}
              </div>
              <p className="text-gray-700 text-md">{testimonial.review}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Testimonials;
